let utils = require('../utils');
let sizeGuideTrigger = null;

/**
 * Generates the modal window on the first call.
 *
 */
function getSizeGuideModal() {
    let isMobile = utils.getCurrentBreakpoint() === 'mobile';
    let modalClassNames = isMobile ? 'slide-in' : 'fade';
    let htmlString = `
        <div class="modal modal-animated size-guide__popup ${modalClassNames}" id="sizeGuidePopup" role="dialog" aria-modal="true" aria-labelledby="sizeGuideModal">
        <span class="enter-message sr-only"></span>
        <div class="modal-dialog modal-dialog-centered" role="document">
            <!-- Modal content-->
            <div class="modal-content">
                <button type="button" class="close size-guide__close ds-btn-circle sm" data-dismiss="modal" aria-label="Close">
                    <svg class="ds-block">
                        <use xlink:href="#close-darkgrey"></use>
                    </svg>
                    <svg class="ds-hover">
                        <use xlink:href="#close-white"></use>
                    </svg>
                </button>
                <div class="modal-body justify-content-center">
                </div>
            </div>
        </div>
    </div>`;
    $('body').append(htmlString);
}

/**
 * Loads and opens the size guide modal for the active trigger.
 *
 * @param {HTMLElement} sizeGuideButton trigger element containing the size guide URL
 */
function openSizeGuide(sizeGuideButton) {
    $('.size-guide__popup').remove();
    sizeGuideTrigger = sizeGuideButton;
    let sizeGuideUrl = $(sizeGuideButton).data('sizeguideurl');

    $.ajax({
        url: sizeGuideUrl,
        method: 'GET',
        success: function (data) {
            let sizeGuideData = data.content;
            getSizeGuideModal();
            $('#sizeGuidePopup .modal-body').html(sizeGuideData);
            $('#sizeGuidebtn').click();
        }
    });
}

/**
 * Moves focus back to the trigger before Bootstrap hides the modal from assistive tech.
 *
 * @param {JQuery} $modal modal being closed
 */
function restoreSizeGuideFocus($modal) {
    let activeElement = document.activeElement;

    if ($modal.length && activeElement && $modal[0].contains(activeElement)) {
        if (sizeGuideTrigger && document.body.contains(sizeGuideTrigger)) {
            $(sizeGuideTrigger).trigger('focus');
        } else if (typeof activeElement.blur === 'function') {
            activeElement.blur();
        }
    }
}

module.exports = {
    QuickViewSideGuide: function () {
        $(document).on('click keydown', '.size-guide', function (event) {
            if (event.type !== 'click' && event.which !== 13 && event.which !== 32) {
                return;
            }

            event.preventDefault();
            openSizeGuide(this);
        });

        $('body').on('hide.bs.modal', '#sizeGuidePopup', function () {
            restoreSizeGuideFocus($(this));
        });
        $('body').on('hidden.bs.modal', '#sizeGuidePopup', function () {
            // eslint-disable-next-line
            if ($('.modal-backdrop.show').length || $('.quickbuy__backdrop.show').length) { 
                $('html').addClass('hide-scroll-and-lock');
            }
        });
    }
};
